import Region from '@/creditflowresearch/domain/Region';
import type { ISubscriptionAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/types';
import { filterAndGroupThemes, buildBaseFilterGroups } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/helpers';

export const absAdapter: ISubscriptionAdapter = {
  shouldUse: () => true,

  filterThemes: (context) => {
    if (!context.currentRegion || !context.currentProduct) {
      return { groupedThemes: {}, themesIds: {} };
    }

    return filterAndGroupThemes(
      context.themes,
      ({ regionId, productId, marketId }) =>
        marketId === null &&
        regionId === context.currentRegion?.id &&
        productId === context.currentProduct?.id,
    );
  },

  getRegionIds: (context) => [context.currentRegion?.id || ''],

  getModalTitle: (context) => {
    const displayName = context.currentRegion?.id === Region.USOA_ID
      ? context.currentRegion?.shortDisplayName || ''
      : context.currentRegion?.abbreviation || '';
    const productAbbr = context.currentProduct?.abbreviation || '';
    return `${ displayName } ${ productAbbr } Email Alerts`;
  },

  shouldFilterByProduct: true,

  buildFilterGroups: (groupedThemes, themesIds, context) => {
    if (!context.currentRegion || !context.currentProduct) {
      return [];
    }

    const regionDisplay = context.currentRegion.id === Region.USOA_ID
      ? context.currentRegion.shortDisplayName
      : context.currentRegion.abbreviation;
    const productAbbr = context.currentProduct.abbreviation;

    return buildBaseFilterGroups(
      groupedThemes,
      themesIds,
      (articleTypeTitle) => `All ${ regionDisplay } ${ productAbbr } ${ articleTypeTitle }`,
    );
  },
};
